import React, { useEffect, useState } from "react";

import { Image, Upload } from "antd";
import ImgCrop from "antd-img-crop";
import { RcFile, UploadFile } from "antd/lib/upload/interface";

import { AvatarCroperDiv } from "./styles";
import { ImageAdd } from "components/Icons/ImageAdd";

export const AvatarCroper: React.FC<{
  getAvatar: (file: File | undefined) => void;
  initial?: string[];
}> = ({ getAvatar, initial }) => {
  const [fileList, setFileList] = useState<UploadFile<RcFile>[]>(
    initial
      ? [
          {
            uid: "1975",
            url: initial[0],
            name: `fileName`,
          },
        ]
      : []
  );
  const [visible, setVisible] = useState(false);
  const [wrongImageFormat, setWrongImageFormat] = useState(false);
  const [currentImage, setCurrentImage] = useState<string>("");
  useEffect(() => {
    getAvatar(
      fileList.length ? (fileList[0].originFileObj as File) : undefined
    );
    // eslint-disable-next-line
  }, [fileList]);

  const customRequest = ({ onSuccess, onError, file }: any) => {
    const checkInfo = () => {
      setTimeout(() => {
        onSuccess(null, file);
      }, 100);
    };

    checkInfo();
  };
  const onChange = async ({ fileList: newFileList }: any) => {
    if(wrongImageFormat) {
      return
    }
    setFileList(newFileList);
  };

  const onPreview = async (file: any) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    setCurrentImage(src);
    setVisible(true);
  };

  const onDelete = (file: UploadFile<any>) => {
    setFileList([]);
    setCurrentImage("");
    getAvatar(undefined);
  };

  async function beforeUpload(file: any) {
    const isJpgOrPng = ['image/jpeg', 'image/png', 'image/bmp'].includes(file.type);
    setWrongImageFormat(!isJpgOrPng)
    return isJpgOrPng
  }

  return (
    <AvatarCroperDiv>
      <ImgCrop grid zoom rotate quality={1} minZoom={0.5}>
        <Upload
          customRequest={customRequest}
          listType="picture-card"
          fileList={fileList}
          onChange={onChange}
          onPreview={onPreview}
          onRemove={onDelete}
          beforeUpload={beforeUpload}
        >
          {fileList.length < 1 && (
            <div className="label-upload">
              <ImageAdd />
              {!initial?.length && (
                <>
                  <p>
                    <span>Upload file</span> or drag & drop
                  </p>
                  <p>PNG or JPG up to 10MB</p>
                </>
              )}
            </div>
          )}
        </Upload>
      </ImgCrop>
      <div style={{ display: "none" }}>
        <Image.PreviewGroup
          preview={{ visible, onVisibleChange: (vis) => setVisible(vis) }}
        >
          <Image src={currentImage} />
        </Image.PreviewGroup>
      </div>
    </AvatarCroperDiv>
  );
};
